import { COBALT_COLORS, ORANGE_COLORS } from '@junglescout/styles-library';
import { DefaultTheme } from 'styled-components';

export const THEMES: Record<string, DefaultTheme> = {
  orange: {
    colors: ORANGE_COLORS,
  },
  cobalt: {
    colors: COBALT_COLORS,
  },
};
